import React from 'react';
import { mapOrders } from 'utils/mappers';
import LOOKUP from 'constants/lookup';
import Pagination from 'screens/components/basic/Pagination';
import CardSimple from 'screens/components/basic/CardSimple';
import GenericTable from 'screens/components/advanced/GenericTable';

const OrderHistory = ({ orders, changePage, pagination }) => {
    return (
        <div className="product-content">
            <CardSimple>
                {orders && <GenericTable
                    className="table_center"
                    multiSelectable={false}
                    enableSelectAll={false}
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                    displayRowCheckbox={false}
                    selectable={false}
                    stripedRows={true}
                    columns={LOOKUP.menu.admin.orderListTableColumns}
                    rows={orders ? mapOrders(orders.list) : []}
                />}
                {orders && <Pagination
                    length={orders.total}
                    itemsPerPage={pagination.itemsPerPage}
                    activePage={pagination.activePage}
                    onPageChange={(e) => changePage(e, "orders")}
                />}
            </CardSimple>
        </div>
    )
}

export default OrderHistory;